import React from 'react';
import ThemeOneSectionFive from './sections/mobile-app-section';
import BannerSection from './sections/banner-section';
import TrustSection from './sections/trust-section';
import PrioritySection from './sections/priority-section';
import MobileAppSection from './sections/mobile-app-section';
import Header1 from '@/feature-module/common/header/header-1';

const HomeThemeOne = (props: any) => {
  const { themeData, collections } = props;
  return (
    <>
      {/* <Header1 themeData={themeData} /> */}
      <div className="home-one-main-wrapper">
        <BannerSection themeData={themeData} />
        <TrustSection themeData={themeData} />
        <PrioritySection themeData={themeData} />
        <MobileAppSection themeData={themeData} />
      </div>
    </>
  );
};

export default HomeThemeOne;
